const VERIFY_EMAIL_KEY = 'esafx_verify_email'
const SIGNUP_PHONE_KEY = 'esafx_signup_phone'
const SIGNUP_PASSWORD_KEY = 'esafx_signup_password'

export function normalizeSignupPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return ''
  if (raw.trim().startsWith('+')) return `+${digits}`
  if (digits.startsWith('62')) return `+${digits}`
  const local = digits.startsWith('0') ? digits.slice(1) : digits
  return `+62${local}`
}

export function setSignupVerifyEmail(email: string) {
  sessionStorage.setItem(VERIFY_EMAIL_KEY, email.trim())
}

export function getSignupVerifyEmail(): string {
  return sessionStorage.getItem(VERIFY_EMAIL_KEY)?.trim() ?? ''
}

export function setSignupPhone(phone: string) {
  const normalized = normalizeSignupPhone(phone)
  if (normalized) sessionStorage.setItem(SIGNUP_PHONE_KEY, normalized)
}

export function getSignupPhone(): string {
  return sessionStorage.getItem(SIGNUP_PHONE_KEY)?.trim() ?? ''
}

export function setSignupPassword(password: string) {
  if (password) sessionStorage.setItem(SIGNUP_PASSWORD_KEY, password)
}

export function getSignupPassword(): string {
  return sessionStorage.getItem(SIGNUP_PASSWORD_KEY) ?? ''
}

export function clearSignupSessionSecrets() {
  sessionStorage.removeItem(SIGNUP_PASSWORD_KEY)
}
